import { ScanSearch, Sliders, Zap, CheckCircle2 } from 'lucide-react'
import { useScrollReveal } from '../../hooks/useScrollReveal.js'
import { useParallax } from '../../hooks/useParallax.js'

const HOW_IT_WORKS = [
  { icon: ScanSearch,   text: 'Understands what you need'                         },
  { icon: Sliders,      text: 'Matches you with the right providers'              },
  { icon: CheckCircle2, text: 'Operates within their predefined guardrails'       },
  { icon: Zap,          text: 'Delivers outcomes fast'                            },
]

export default function About() {
  const headerRef = useScrollReveal()
  const bodyRef   = useScrollReveal({ threshold: 0.1 })
  const bgOrbRef  = useParallax({ speed: 0.22 })

  return (
    <section id="about" className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div
          ref={bgOrbRef}
          className="parallax-layer absolute top-0 right-0 w-[500px] h-[500px]
                     rounded-full bg-accent/4 blur-[110px]"
        />
      </div>

      <div className="section-container relative z-10">

        {/* Header */}
        <div ref={headerRef} className="reveal max-w-2xl mb-10 md:mb-14">
          <p className="eyebrow mb-3">
            <span className="w-5 h-px bg-primary" />
            About DecidA
          </p>
          <h2
            className="font-extrabold text-brand-dark mb-6"
            style={{ fontSize: 'clamp(1.9rem, 3.5vw, 2.75rem)' }}
          >
            People don&rsquo;t search.<br className="hidden sm:block" />
            They ask.
          </h2>
          <p className="text-base text-brand-gray leading-relaxed mb-4">
            Every day, millions of people solve problems the same way: &ldquo;Who knows someone?&rdquo;
            DecidA turns that behavior into a system and delivers real outcomes in minutes.
          </p>
          <p className="text-base text-brand-gray leading-relaxed">
            Instead of browsing listings, sending messages, or hoping for replies,
            you submit one clear request.
          </p>
        </div>

        {/* How DecidA works — 4-step list */}
        <div ref={bodyRef} className="reveal max-w-xl mb-10 md:mb-14">
          <p className="text-xs font-bold tracking-widest uppercase text-primary mb-5">
            DecidA
          </p>
          <ul className="flex flex-col gap-4" role="list">
            {HOW_IT_WORKS.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-center gap-4">
                <div className="w-9 h-9 rounded-xl bg-primary-light flex items-center
                                justify-center flex-shrink-0 shadow-sm">
                  <Icon className="w-4 h-4 text-primary" aria-hidden="true" />
                </div>
                <p className="text-base font-medium text-brand-dark">{text}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* Callout */}
        <div className="reveal rounded-2xl bg-brand-dark px-8 py-7 max-w-xl">
          <p className="text-base text-white/50 font-medium mb-1">No noise. No chasing. No guesswork.</p>
          <p className="text-xl font-extrabold text-white tracking-tight">
            Stop asking around. Ask DecidA.
          </p>
        </div>

      </div>
    </section>
  )
}
